/* __next_internal_client_entry_do_not_use__ TypographyGhostWithOpacityStyle,LoadableTypography auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { createFallbackHandler, FallbackOpacityAnimation } from "@faire/retailer-visitor-shared/components/GhostLoading/FallbackHandler";
import { isEnumKey } from "@faire/web--source/common/typescriptUtils";
import { DefaultTheme } from "@faire/web--source/slate/Theme";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";
export var TypographyGhostWithOpacityStyle = function(duration) {
    return css([
        "background-color:",
        ";color:",
        ";",
        ""
    ], Core.surface.muted, Core.surface.muted, FallbackOpacityAnimation(duration));
};
var LoadableTypographyHandler = createFallbackHandler(Typography, {
    backgroundStyle: TypographyGhostWithOpacityStyle("0.2s"),
    loadedStyle: FallbackOpacityAnimation("0.2s")
});
var StyledLoadableTypographyHandler = styled(LoadableTypographyHandler).withConfig({
    componentId: "sc-7c25e73c-0"
})([
    "",
    ""
], function(props) {
    var _props_loadingWidth;
    return !props.isLoaded && css([
        "",
        ";margin:",
        "px 0 ",
        "px;width:",
        ";"
    ], props.$lineHeight && css([
        "line-height:",
        ";"
    ], props.$lineHeight), props.$loadingInsetTop || 0, props.$loadingInsetBottom || 0, (_props_loadingWidth = props.loadingWidth) !== null && _props_loadingWidth !== void 0 ? _props_loadingWidth : "auto");
});
export var LoadableTypography = function(props) {
    var fallback = props.fallback, children = props.children, isLoaded = props.isLoaded, asTag = props.asTag, loadingInsetBottom = props.loadingInsetBottom, loadingInsetTop = props.loadingInsetTop, rest = _object_without_properties(props, [
        "fallback",
        "children",
        "isLoaded",
        "asTag",
        "loadingInsetBottom",
        "loadingInsetTop"
    ]);
    var lineHeight = function() {
        var fonts = DefaultTheme.fonts.sansSerif;
        var getNumFromPx = function(str) {
            return str.substring(0, str.length - 2);
        };
        var variant = "p";
        for(var prop in props){
            if (isEnumKey(fonts, prop)) {
                variant = prop;
            }
        }
        var currentLineHeight = getNumFromPx(fonts[variant].lineHeight);
        if (typeof loadingInsetTop === "number" || typeof loadingInsetBottom === "number") {
            return "calc(".concat(currentLineHeight, " - ").concat(calculateInset(loadingInsetTop, loadingInsetBottom), "px)");
        }
        return undefined;
    }();
    return /*#__PURE__*/ _jsx(StyledLoadableTypographyHandler, _object_spread_props(_object_spread({}, rest), {
        asTag: asTag,
        isLoaded: isLoaded,
        $lineHeight: lineHeight,
        $loadingInsetTop: loadingInsetTop,
        $loadingInsetBottom: loadingInsetBottom,
        children: isLoaded ? children : fallback !== null && fallback !== void 0 ? fallback : children
    }));
};
var calculateInset = function(top, bottom) {
    return (top !== null && top !== void 0 ? top : 0) + (bottom !== null && bottom !== void 0 ? bottom : 0);
};
